import React from "react";
import { GM_Point } from "../../shared-types/WeatherTypes";
import { ServiceWorkerStatus } from "../../service-worker/register";
import { PanelContextType } from "../PanelContext";
import { SpotterWave } from "../../shared-types/SpotterTypes";

export type RasterWeatherLayer =
  | "wind"
  | "combinedWaves"
  | "currents"
  | "barometricPressure"
  | null;
export type VectorWeatherLayer = "arrows" | "wind-barbs" | null;

export type WeatherMapLayers = {
  raster: RasterWeatherLayer;
  vector: VectorWeatherLayer;
  showVectors: boolean;
  showPressure: boolean;
  showPressureCenters: boolean;
  showSpotters: boolean;
  colorSpotters: boolean;
  showTropicalStorms: boolean;
};

export type SpotterMapInspector = {
  type: "spotter";
  spotterId: string;
};
export type WeatherMapInspector = {
  type: "weather";
  position: GM_Point;
};
export type MapInspector = WeatherMapInspector | SpotterMapInspector;

export type HighlightedMapElement = {
  type: "spotter";
  id: string;
};
export type MapDimensions = {
  width: number;
  height: number;
};

export type UIContextType = {
  inspectSpotter: (spotterId: string) => void;
  inspectWeather: (position: GM_Point) => void;
  activeMapInspector: MapInspector | null;
  activeSpotterData: SpotterWave[] | undefined;
  highlightedMapElements: HighlightedMapElement[];
  isSpotterHighlighted: (id: string) => boolean;
  clearMapInspector: () => void;
  clearHighlightedMapElements: () => void;
  mapDimensions: MapDimensions;
  setMapDimensions: (newDimensions: MapDimensions) => void;

  setWeatherMapLayers: (newLayers: WeatherMapLayers) => void;
  weatherMapLayers: WeatherMapLayers;

  serviceWorkerStatus?: ServiceWorkerStatus;

  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  sidebarPanelState: PanelContextType | null;
  timelinePanelState: PanelContextType | null;
  mapOverlayPanelState: PanelContextType | null;
  setPanelLayoutMounted: (state: boolean) => void;
};

export const UIContextDefaults: UIContextType = {
  inspectSpotter: (spotterID: string) => {},
  inspectWeather: (point: GM_Point) => {},
  activeMapInspector: null,
  activeSpotterData: undefined,
  highlightedMapElements: [],
  isSpotterHighlighted: (id: string) => false,
  clearMapInspector: () => {},
  mapDimensions: { width: 0, height: 0 },
  setMapDimensions: () => null,

  clearHighlightedMapElements: () => {},

  setWeatherMapLayers: () => null,
  weatherMapLayers: {
    raster: "combinedWaves",
    showVectors: false,
    showPressure: false,
    showPressureCenters: false,
    vector: "wind-barbs",
    showSpotters: true,
    colorSpotters: false,
    showTropicalStorms: false,
  },

  serviceWorkerStatus: {
    hasCheckedForUpdate: false,
    isNewAppReady: false,
    isNewAppPublished: false,
    updateNow: () => null,
    autoRefreshOnUpdate: false,
    needsRefresh: false,
  },

  isLoading: false,
  setIsLoading: () => null,
  sidebarPanelState: null,
  timelinePanelState: null,
  mapOverlayPanelState: null,
  setPanelLayoutMounted: () => null,
};
const UIContext = React.createContext<UIContextType>(UIContextDefaults);

export default UIContext;
